var _path, _path2, _path3, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVerify(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M3 12L4.5 14.5L5.5 19H8.5L12 21L15.5 19L19 18V14.5L20 13.5L20.5 12.5V11L19 9.5V8L18 5.5H17L15.5 5L12 3L11 3.5L9 5H8L5.5 6L5 9.5L3 12Z",
    fill: "#07553F"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7543 3.45879C11.4721 2.84707 12.5279 2.84707 13.2457 3.45879L14.4667 4.49929C14.7743 4.76143 15.1567 4.91985 15.5596 4.952L17.1587 5.07961C18.0988 5.15463 18.8454 5.90117 18.9204 6.8413L19.048 8.4404C19.0802 8.84327 19.2386 9.22573 19.5007 9.53333L20.5412 10.7543C21.1529 11.4721 21.1529 12.5279 20.5412 13.2457L19.5007 14.4667C19.2386 14.7743 19.0802 15.1567 19.048 15.5596L18.9204 17.1587C18.8454 18.0988 18.0988 18.8454 17.1587 18.9204L15.5596 19.048C15.1567 19.0802 14.7743 19.2386 14.4667 19.5007L13.2457 20.5412C12.5279 21.1529 11.4721 21.1529 10.7543 20.5412L9.53333 19.5007C9.22573 19.2386 8.84327 19.0802 8.4404 19.048L6.8413 18.9204C5.90117 18.8454 5.15463 18.0988 5.07961 17.1587L4.952 15.5596C4.91985 15.1567 4.76143 14.7743 4.49929 14.4667L3.45879 13.2457C2.84707 12.5279 2.84707 11.4721 3.45879 10.7543L4.49929 9.53333C4.76143 9.22573 4.91985 8.84327 4.952 8.4404L5.07961 6.8413C5.15463 5.90117 5.90117 5.15463 6.8413 5.07961L8.4404 4.952C8.84327 4.91985 9.22573 4.76143 9.53333 4.49929L10.7543 3.45879Z",
    stroke: "url(#paint0_linear_2486_12789)",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.7071 10.7071C16.0976 10.3166 16.0976 9.68342 15.7071 9.29289C15.3166 8.90237 14.6834 8.90237 14.2929 9.29289L15.7071 10.7071ZM11 14L10.2929 14.7071C10.6834 15.0976 11.3166 15.0976 11.7071 14.7071L11 14ZM9.70711 11.2929C9.31658 10.9024 8.68342 10.9024 8.29289 11.2929C7.90237 11.6834 7.90237 12.3166 8.29289 12.7071L9.70711 11.2929ZM14.2929 9.29289L10.2929 13.2929L11.7071 14.7071L15.7071 10.7071L14.2929 9.29289ZM11.7071 13.2929L9.70711 11.2929L8.29289 12.7071L10.2929 14.7071L11.7071 13.2929Z",
    fill: "white"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_f_2486_12789)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15 5L18 5.5L19 9L21 12L19 15",
    stroke: "url(#paint1_linear_2486_12789)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_f_2486_12789",
    x: 12.918,
    y: 2.50684,
    width: 10.6836,
    height: 14.7705,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    result: "effect1_foregroundBlur_2486_12789"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2486_12789",
    x1: 4,
    y1: 8,
    x2: 19,
    y2: 17.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#00E5A6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#32B994"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2486_12789",
    x1: 20,
    y1: 5,
    x2: 19,
    y2: 15.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0.67
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "white",
    stopOpacity: 0.27
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVerify);
export default __webpack_public_path__ + "static/media/verify.3a7d92cd9b2e5dd0508e6f99707da0c6.svg";
export { ForwardRef as ReactComponent };